import React, { useState, useCallback, useEffect, useMemo } from "react";
import { Modal, Tag, Input, Checkbox, Spin } from "antd";
import { debounce } from "lodash";
import moment from "moment";
import BUDGET_API from "../../../../../apis/budget.api";
export const AddRecurringPatternModalFromTable = ({
  title,
  open,
  handleCancel,
  handleChange,
  data,
  handleSave,
  selectAll,
  setSelectAll,
  selectedObject,
  selectecPrediction
}) => {
  const [inputValue, setInputValue] = useState("");
  const [patterns, setPatterns] = useState((data && data.patterns) || []);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [searchResults, setSearchResults] = useState([]);
  // const [selectAll, setSelectAll] = useState(false);
  const [applyToExistingTransactions, setApplyToExistingTransactions] = useState(false);
  const [selectedTransactionsMap, setSelectedTransactionsMap] = useState({});
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalFoundTransactions, setTotalFoundTransactions] = useState(null);
  const [loadingMore, setLoadingMore] = useState(false);
  const selectedTransactions = Object.values(selectedTransactionsMap).flat();

  const handleInputChange = (e) => {
    const value = e.target.value;
    const prevInput = inputValue;
    setInputValue(value);
    setSelectAll(false);
    // if (value === "") {
    //   setTotalFoundTransactions(null);
    // }

    // Remove transactions for previous input if not saved as tag
    // if (prevInput && !patterns.includes(prevInput)) {
    //   setSelectedTransactionsMap((prev) => {
    //     const newMap = { ...prev };
    //     delete newMap[prevInput];
    //     return newMap;
    //   });
    // }
  };

// OLD LOGIC OF FUNCTION
  // const handleInputConfirm = () => {
  //   if (inputValue && !patterns.includes(inputValue)) {
  //     const updatedPatterns = [...patterns, inputValue];
  //     setPatterns(updatedPatterns);
  //     handleChange("patterns", updatedPatterns);
  //   }
  //   setInputValue("");
  //   setSelectAll(false);
  // };

  const handleInputConfirm = () => {
    // if (patterns.length >= 1) return;

    let updatedPatterns = [...patterns];
    if (inputValue && !patterns.includes(inputValue)) {
      updatedPatterns = [...patterns, inputValue];
      setPatterns(updatedPatterns);
      handleChange("patterns", updatedPatterns);
    }
    setInputValue("");
    // commented to selectAll true will fix the logic soon
    // setSelectAll(false);
    return updatedPatterns;
  };

  const handleTagClose = (removedTag) => {
    const updatedPatterns = patterns.filter((tag) => tag !== removedTag);
    setPatterns(updatedPatterns);
    handleChange("patterns", updatedPatterns);

    // Remove transactions associated with removed tag
    setSelectedTransactionsMap((prev) => {
      const newMap = { ...prev };
      delete newMap[removedTag];
      return newMap;
    });
  };

  const toggleTransactionSelection = (transaction) => {
    if (!inputValue) return;

    setSelectedTransactionsMap((prev) => {
      const existing = prev[inputValue] || [];
      const isSelected = existing.some((t) => t.id === transaction.id);

      const updated = isSelected
        ? existing.filter((t) => t.id !== transaction.id)
        : [...existing, transaction];

      return { ...prev, [inputValue]: updated };
    });
  };
//   const searchPatternTransactions = useMemo(
//     () =>
//       debounce(async (query, page = 1, limit = 10, append = false) => {
//         if (!query) {
//           setSearchResults([]);
//           return;
//         }
  
//         const isFirstPage = page === 1;
  
//         if (isFirstPage) {
//           setLoading(true);
//         } else {
//           setLoadingMore(true);
//         }
  
//         try {
//           const response = await BUDGET_API.searchRecurringAppliedTransaction(
//             page,
//             limit,
//             query
//           );
  
//           if (response && response.data) {
//             const newResults = response.data;
  
//             //  Append or Replace Results
//             setSearchResults((prev) =>
//               append ? [...prev, ...newResults] : newResults
//             );
  
//             setTotalPages(response.totalPages);
//             setCurrentPage(page);
//             setTotalFoundTransactions(response.total);
  
//             //  Handle selectAll logic here itself
//             if (selectAll) {
//               setSelectedTransactionsMap((prev) => {
//                 const existing = prev[query] || [];
//                 const existingIds = new Set(existing.map((t) => t.id));
//                 const newSelections = newResults.filter(
//                   (t) => !existingIds.has(t.id)
//                 );
//                 return {
//                   ...prev,
//                   [query]: [...existing, ...newSelections],
//                 };
//               });
//             }
//           } else {
//             setSearchResults([]);
//             setTotalPages(1);
//             setCurrentPage(1);
//             setTotalFoundTransactions(null);
//           }
//         } catch (error) {
//           console.error("Error fetching transactions:", error);
//         }
  
//         if (isFirstPage) {
//           setLoading(false);
//         } else {
//           setLoadingMore(false);
//         }
//       }, 500),
//     [selectAll] // Add `selectAll` as dependency
//   );
  // PREVIOUS LOGIC WITHOUT SELECTALL PAGINATION
  // const searchPatternTransactions = useMemo(
  //   () =>
  //     debounce(async (query, page = 1, limit = 10) => {
  //       if (!query) {
  //         setSearchResults([]);
  //         return;
  //       }
  //       setLoading(true);
  //       try {
  //         const response = await BUDGET_API.searchRecurringAppliedTransaction(
  //           page,
  //           limit,
  //           query
  //         );
  //         if (response && response.data) {
  //           setSearchResults((prev) =>
  //             page === 1 ? response.data : [...prev, ...response.data]
  //           );
  //           setTotalPages(response.totalPages);
  //           setTotalFoundTransactions(response.total);
  //           setCurrentPage(page);
  //         } else {
  //           setTotalFoundTransactions(null);
  //           setTotalPages(1);
  //           setCurrentPage(1);
  //           setSearchResults([]);
  //         }
  //       } catch (error) {
  //         console.error("Error fetching transactions:", error);
  //       }
  //       setLoading(false);
  //     }, 500),
  //   []
  // );
//   useEffect(() => {
//     searchPatternTransactions(inputValue, 1);
//   }, [inputValue]);
//   useEffect(() => {
//     return () => {
//       searchPatternTransactions.cancel();
//     };
//   }, []);
//   const handleScroll = () => {
//     const container = document.getElementById("transactions-search");
//     if (!container) return;

//     const { scrollTop, scrollHeight, clientHeight } = container;
//     if (
//       scrollTop + clientHeight >= scrollHeight - 10 &&
//       !loadingMore &&
//       currentPage < totalPages
//     ) {
//       // setLoadingMore(true);
//       // searchPatternTransactions(inputValue, currentPage + 1);
//       // setLoadingMore(false);
//       const nextPage = currentPage + 1;
//       searchPatternTransactions(inputValue, nextPage, 10, true);
//     }
//   };
  // PREVIOUS LOGIC WITHOUT SELECTALL PAGINATION
  // const handleScroll = async () => {
  //   const container = document.getElementById("transactions-search");
  //   if (!container) return;
  
  //   const { scrollTop, scrollHeight, clientHeight } = container;
  
  //   if (
  //     scrollTop + clientHeight >= scrollHeight - 10 &&
  //     !loadingMore &&
  //     currentPage < totalPages
  //   ) {
  //     setLoadingMore(true);
  //     try {
  //       const nextPage = currentPage + 1;
  //       const response = await BUDGET_API.searchRecurringAppliedTransaction(
  //         nextPage,
  //         10,
  //         inputValue
  //       );
  //       if (response && response.data) {
  //         const newResults = response.data;
  
  //         setSearchResults((prev) => [...prev, ...newResults]);
  //         setTotalPages(response.totalPages);
  //         setCurrentPage(nextPage);
  
  //         // 👇 If selectAll is active, also add new items to selectedTransactionsMap
  //         if (selectAll) {
  //           setSelectedTransactionsMap((prev) => {
  //             const existing = prev[inputValue] || [];
  //             const existingIds = new Set(existing.map((t) => t.id));
  //             const newSelections = newResults.filter(
  //               (t) => !existingIds.has(t.id)
  //             );
  //             return {
  //               ...prev,
  //               [inputValue]: [...existing, ...newSelections],
  //             };
  //           });
  //         }
  //       }
  //     } catch (err) {
  //       console.error("Error loading more transactions:", err);
  //     }
  //     setLoadingMore(false);
  //   }
  // };

//   useEffect(()=>{
//     console.log("newModak>>>>>>>>>>>",selectedTransactions, updatedPatterns)
//   },[selectedTransactions, updatedPatterns])
  

  const handleSelectAllChange = (e) => {
    const checked = e.target.checked;
    setSelectAll(checked);

    if (!inputValue) return;

    if (checked) {
      setSelectedTransactionsMap((prev) => {
        const existing = prev[inputValue] || [];
        const existingIds = new Set(existing.map((t) => t.id));
        const newSelections = searchResults.filter(
          (t) => !existingIds.has(t.id)
        );
        return {
          ...prev,
          [inputValue]: [...existing, ...newSelections],
        };
      });
    } else {
      setSelectedTransactionsMap((prev) => {
        const newMap = { ...prev };
        newMap[inputValue] = [];
        return newMap;
      });
    }
  };
  
  const handleApplyRuleToExistingTransactions = (e) => {
    setApplyToExistingTransactions(prev => !prev)
    handleChange(e.target.name, e.target.checked)
  }

  useEffect(()=>{
    if(selectecPrediction && selectecPrediction.itemName){
      setInputValue(selectecPrediction.itemName || "")
      setPatterns([selectecPrediction.itemName])
    } 
      
  },[selectecPrediction])


  return (
    <div>
      <Modal
        visible={open}
        footer={null}
        onOk={handleCancel}
        onCancel={handleCancel}
        closable={false}
        centered
      >
        <h3 className="modaltitle">{title}</h3>
        <div
          style={{ marginTop: "1rem", maxHeight: "25rem", overflow: "scroll" }}
        >
          <div style={{ marginBottom: "8px" }}>
            <h3 className="inputTitle">
              Rule <span style={{ color: "red" }}>*</span>
            </h3>
            <input
              className="roleInput"
              placeholder="Rule Name"
              name="token"
              value={data && data.token || ""}
              onChange={(e) => handleChange(e.target.name, e.target.value)}
            />
          </div>
          <div>
            <Checkbox
              name="applyRuleToExistingTransactions"
              id="applyRuleToExistingTransactions"
              checked={applyToExistingTransactions}
              onChange={handleApplyRuleToExistingTransactions}
            />
            <label htmlFor="applyRuleToExistingTransactions" style={{ marginLeft: 8 }}>
               Do you want to apply this rule to existing transactions?
            </label>
          </div>
          

          <div style={{ marginTop: "1rem" }}>
            <h3 className="inputTitle">
              Patterns{" "}
              <span style={{ fontSize: "12px" }}>
                (Press enter to add Pattern)
              </span>
            </h3>
            {patterns.map((pattern) => (
              <Tag
                key={pattern}
                // closable
                // onClose={() => handleTagClose(pattern)}
                style={{ marginBottom: "0.5rem" }}
              >
                {pattern}
              </Tag>
            ))}
            <div className="addPatternButtonInput">
              <Input
                className="roleInput"
                placeholder="Enter pattern and press Enter"
                value={inputValue}
                onChange={handleInputChange}
                onPressEnter={handleInputConfirm}
                // disabled={patterns.length >= 1}
                disabled={true}
              />
              <div className={`addPatternButton ${patterns.length >= 1 ? 'disabled' : ''}`}
                  onClick={patterns.length >= 1 ? undefined : handleInputConfirm}
                  style={{
                    cursor: patterns.length >= 1 ? 'not-allowed' : 'pointer',
                    opacity: patterns.length >= 1 ? 0.5 : 1
                  }}>
                + Add
              </div>
            </div>
            {loading && <Spin />}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              {/* {searchResults.length > 0 && (
                <div>
                  <Checkbox
                    id="selectAllSearch"
                    checked={selectAll}
                    onChange={handleSelectAllChange}
                  />
                  <label htmlFor="selectAllSearch" style={{ marginLeft: 8 }}>
                    Select All
                  </label>
                </div>
              )} */}
              {/* <div
                style={{
                  cursor: "pointer",
                  textDecoration: !selectAll ? "underline" : 'none',
                  color: "#2a3da3",
                  paddingInline:"4px"
                }}
                onClick={() => {
                  console.log("selectedTransactions", selectedTransactions);
                  !selectAll && setIsModalOpen(true);
                }}
              >
                {(selectedObject
                  ? (selectedObject.length > 0 && totalFoundTransactions && 
                      `Total Transactions ${totalFoundTransactions}`)
                  : (selectedObject.length > 0 && 
                      `Selected Transactions ${selectedTransactions.length}`))}
              </div> */}
              <div>
                {selectedObject.length > 0 &&
                  "Total Transactions " + selectedObject.length}
              </div>
            </div>

            <div
              className="searchResults"
              style={{ maxHeight: "10rem", overflowY: "auto" }}
              id="transactions-search"
            //   onScroll={handleScroll}
            >
              {selectedObject.length > 0 ? (
                selectedObject.map((transaction) => {
                  {/* const isSelected =
                    (selectedTransactionsMap[inputValue] &&
                      selectedTransactionsMap[inputValue].some(
                        (t) => t.id === transaction.id
                      )) ||
                    false; */}
                  return (
                    <div
                      key={transaction.id}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent:'space-between',
                        padding: "8px",
                        borderBottom: "1px solid #ddd",
                        cursor: "pointer",
                      }}
                    //   onClick={() => toggleTransactionSelection(transaction)}
                    >
                      <div>
                        {/* <Checkbox
                        //   checked={isSelected}
                          onClick={(e) => e.stopPropagation()}
                          onChange={(e) => {
                            e.stopPropagation();
                            toggleTransactionSelection(transaction);
                          }}
                        /> */}
                        <span style={{ marginLeft: "1rem" }}>
                          {transaction.itemName}
                        </span>
                      </div>
                      <span style={{ marginLeft: "1rem" }}>
                        {transaction.date
                          ? moment(transaction.date).format("MM-DD-YYYY")
                          : "N/A"}
                      </span>
                      {transaction.amount &&
                       <span style={{ marginLeft: "1rem" }}>
                        {`$ ${transaction.amount.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}` }
                      </span>
                      }
                    </div>
                  );
                })
              ) : (
                <p style={{ color: "#aaa", textAlign: "center" }}>
                  No transactions found
                </p>
              )}
            </div>
          </div>
        </div>
        <div className="buttonsMain">
          <button className="cancelbutton" onClick={handleCancel}>
            Cancel
          </button>
          <button
            className="savebutton"
            disabled={(!data || !data.token || (selectedObject.length < 1 || patterns.length < 1))}
            onClick={() => {
              // handleSave(selectedTransactions);
              const updatedPatterns = handleInputConfirm(); 
              handleSave("selectedObject", updatedPatterns); 
            }}
          >
            Save
          </button>
        </div>
      </Modal>
      <Modal
        visible={isModalOpen}
        footer={null}
        onOk={() => setIsModalOpen(false)}
        onCancel={() => setIsModalOpen(false)}
        closable={false}
        centered
      >
        <h3 className="modaltitle">Transaction Details</h3>
        <h3 className="modaltitle">
          {selectedTransactions.length} Transactions
        </h3>

        <div>
          <div
            className=""
            style={{ height: "18rem", maxHeight: "18rem", overflow: "auto" }}
            id="transactions-main"
          >
            {selectedTransactions && selectedTransactions.length > 0 ? (
              <table id="clients">
                <thead>
                  <tr>
                    <th
                      style={{
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                      }}
                    >
                      Date
                    </th>
                    <th>Name</th>
                    <th>Category</th>
                  </tr>
                </thead>
                <tbody style={{}}>
                  {selectedTransactions &&
                    selectedTransactions.map((data, index) => (
                      <tr key={index}>
                        <td>
                          {data && data.date
                            ? moment(data.date).format("MM-DD-YYYY")
                            : "N/A"}
                        </td>
                        <td>{data && data.itemName ? data.itemName : "N/A"}</td>
                        <td>
                          {data &&
                          data.transactionCategory &&
                          data.transactionCategory.categoryName
                            ? data.transactionCategory.categoryName
                            : "N/A"}
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            ) : (
              <h3 className="inputTitle">No Transaction to Show</h3>
            )}
          </div>
        </div>

        <div className="buttonsMain" style={{ justifyContent: "center" }}>
          <button
            className="savebutton"
            onClick={() => {
              setIsModalOpen(false);
            }}
          >
            Close
          </button>
        </div>
      </Modal>
    </div>
  );
};
